<template>
  <div id="app">
    <vue-snotify />
    <navbar
      v-show="
        isLoggedSGQIn &&
        currentRouteName !== 'NotFound' &&
        currentRouteName !== 'Unauthorized'
      "
    />
    <router-view />
  </div>
</template>

<script>
import '@/assets/libs/fontawesome/css/all.min.css'
import '@/assets/template/css/sb-admin-2.min.css'
import '@/assets/template/css/style.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import Navbar from '@/components/commons/Navbar.vue'

export default {
  name: 'App',

  components: {
    Navbar,
  },

  computed: {
    isLoggedSGQIn() {
      return this.$store.getters.isLoggedSGQIn
    },

    currentRouteName() {
      return this.$route.name
    },
  },
}
</script>
